export default __webpack_public_path__ + "static/um-6dbcc1c44669eb533840d606baadcf06.svg";